// extracted by mini-css-extract-plugin
export default {"systemMsg":"SystemMessage__systemMsg--PLECL"};